import React from 'react';
import { PageHero, CtaRow } from '../PublicLayout';
import { HOW_IT_WORKS_STEPS } from '../content';

export default function HowItWorksPage() {
  return (
    <>
      <PageHero
        eyebrow="Simple flow"
        title="How LockedIn works"
        subtitle="From picking a matchup to claiming earnings — here's the whole journey, step by step."
      />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pb-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {HOW_IT_WORKS_STEPS.map((s) => (
            <div key={s.step} className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
              <span className="text-[10px] font-black text-emerald-500/70 uppercase tracking-[0.3em]">Step {s.step}</span>
              <h3 className="text-base font-black uppercase tracking-tight text-white mb-2 mt-3">{s.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <CtaRow />
      </section>
    </>
  );
}
